<template>
  <div class="home">
    <!--================Home Banner Area =================-->
<section class="home_banner_area">
   <div class="banner_inner" >
      <div class="container">
         <div class="row">
            <div class="col-lg-5">
               <div data-aos="fade-up" class="banner_content">
                  <h2 class="color-black">GitLeaf is an IT brand.    
                  <br>
                  We're offers <br>
                  <vue-typer
                     :text='["Web App" , "Desktop App", "Mobile App", "IOT",]'
                     :repeat='3'
                     :shuffle='false'
                     initial-action='typing'
                     :pre-type-delay='70'
                     :type-delay='70'
                     :pre-erase-delay='2000'
                     :erase-delay='250'
                     erase-style='select-all'
                     :erase-on-complete='false'
                     caret-animation='blink'
                  ></vue-typer> 
                  <br>
                     Development services.
                  </h2>
                  <p style="color: black;">
                     GitLeaf, we have a team of knowledgeable developers and creative designers that can implement mobile and web applications for handheld devices of varying complexity.
                  </p>
                  <div class="d-flex align-items-center">
                     <a class="primary_btn" href="#section_gap features_area" style="border-color: black; color: black;"><span>Get Started</span></a>
                  </div>
               </div>
            </div>
            <div class="col-lg-7">
               <div class="home_right_img" data-aos="fade-up"> </div>
            </div>
         </div>
      </div>
   </div>
</section>
<!--================End Home Banner Area =================-->
<!--================Start Features Area =================-->
<section class="section_gap features_area" id="section_gap features_area">
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-lg-8 text-center">
            <div class="main_title" data-aos="fade-up">
               <p class="top_title">Exclusive Stunning Features</p>
               <h2>Our Awesome Services</h2>
            </div>
         </div>
      </div>
      <div class="row align-items-center">
         <div class="col-lg-5">
            <div class="left_features" data-aos="fade-up">
              <center>
                <img class="img-fluid" src="img/GLLogo.svg" title="GitLeaf Logo" alt="GitLeaf Logo">
              </center>
            </div>
         </div>
         <div class="col-lg-5 offset-lg-1" data-aos="fade-up">
            <!-- single features -->
            <div class="single_feature">
               <div class="feature_head">
                  <span class="lnr">📟</span>
                  <h4> IOT Development</h4>
               </div>
               <div class="feature_content">
                  <p>Our highly creative team of designers always excels in creating unique product identity and out-of-the-box designs that speaks on its own!</p>
               </div>
            </div>
            <!-- single features -->
            <div class="single_feature">
               <div class="feature_head">
                  <span class="lnr">📱</span>
                  <h4>Mobile App Development [ iOS, Android ]</h4>
               </div>
               <div class="feature_content">
                  <p>Our profound knowledge of mobile technologies & frameworks, help us create secure & scalable Mobile Apps with great UX.</p>
               </div>
            </div>
            <!-- single features -->
            <div class="single_feature">
               <div class="feature_head">
                  <span class="lnr">🌐</span>
                  <h4>Web Design & Development</h4>
               </div>
               <div class="feature_content">
                  <p>Our expert in-house team uses cutting edge technologies to build softwares and custom web applications that are stunning, robust and scalable.</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>
<!--================End Features Area =================-->
<!--================Recent Update Area =================-->
<!-- <section class="recent_update_area">
   <div class="container">
      <div class="recent_update_inner" data-aos="fade-up">
         <ul class="nav nav-tabs justify-content-center" id="myTab" role="tablist">
            <li class="nav-item">
               <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                  <span class="lnr lnr-screen"></span>
                  <h6>Mobile App Development</h6>
               </a>
            </li>
            <li class="nav-item">
               <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
                  aria-selected="false">
                  <span class="lnr lnr-screen"></span>
                  <h6>Web & Software Development</h6>
               </a>
            </li>
            <li class="nav-item">
               <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact"
                  aria-selected="false">
                  <span class="lnr lnr-screen"></span>
                  <h6>Internet Of Things Development</h6>
               </a>
            </li>
         </ul>
         <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
               <div class="row recent_update_text align-items-center">
                  <div class="col-lg-5">
                     <div class="common_style">
                        <p class="line">Modern technology with mobile apps</p>
                        <h3>Mobile App Development<br />  Services We Offer</h3>
                        <p>A perfect blend of innovation and business solutions offered in a mobile application. Drive and deliver successful business and scale it to new heights with our mobile app development services offering the best mobile app solutions. The best mobile applications can be defined by the style it holds in the User Interface (UI) and the way it provides the User Experience (UX). We blend the best of both to offer top mobile application solutions that caters to your business requirements.</p>
                        <a class="primary_btn" href="#"><span>Learn More</span></a>
                     </div>
                  </div>
                  <div class="col-lg-6">
                     <div class="chart_img">
                        <img class="img-fluid" src="img/chart.png" alt="">
                     </div>
                  </div>
               </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
               <div class="row recent_update_text align-items-center">
                  <div class="col-lg-5">
                     <div class="common_style">
                        <p class="line"> The cross plateform software with real time</p>
                        <h3>Web & Software <br /> Development</h3>
                        <p>Internet being the faster and cheaper means to access the global market, ensuring effective presence of your business profile, products and services in the world wide web, will definitely bring you a host of new opportunities. We build functional and practical web applications to suite your budget and requirement.</p>
                        <a class="primary_btn" href="#"><span>Learn More</span></a>
                     </div>
                  </div>
                  <div class="col-lg-6">
                     <div class="chart_img">
                        <img class="img-fluid" src="img/chart.png" alt="">
                     </div>
                  </div>
               </div>
            </div>
            <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
               <div class="row recent_update_text align-items-center">
                  <div class="col-lg-5">
                     <div class="common_style">
                        <p class="line">Smart devices innovative with IOT</p>
                        <h3>Internet Of Things <br /> [IOT] Development</h3>
                        <p>The evolution of Internet of Things (IoT) has made world closer to everyone, it has now become an everyday essential to many of us. Knowing advantages and the marvels IoT can do, Cyber Concepts team is gearing to handle IoT projects.</p>
                        <a class="primary_btn" href="#"><span>Learn More</span></a>
                     </div>
                  </div>
                  <div class="col-lg-6 text-right">
                     <div class="chart_img">
                        <img class="img-fluid animate" src="img/chart.png" alt="">
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section> -->
<!--================ Recent Update Area =================-->
<!--================Start Big Features Area =================-->
<section class="section_gap big_features">
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-lg-8 text-center">
            <div class="main_title" data-aos="fade-up">
               <p class="top_title">Features Specifications</p>
               <h2>Efficiency consists in a resolute mind!</h2>
            </div>
         </div>
      </div>
      <div class="row features_content" data-aos="fade-up">
         <div class="col-lg-4 offset-lg-1">
            <div class="big_f_left">
               <img class="img-fluid " src="img/f-img1.svg" alt="">
            </div>
         </div>
         <div class="col-lg-4 offset-lg-2">
            <div class="common_style">
               <p class="line">Modern Design Trends</p>
               <h3>Focussing the future</h3>
               <p>As technology continues to develop, it is important to understand the preferences of people from across the world, especially in Sri Lanka. It’s quite obvious that mobile applications and websites have taken over most of the modern day businesses. We use our mobile phones for almost everything in the modern day. So by understanding the modern day needs, we build exceptional mobile/web platforms with beautifully designed interfaces.</p>
               <!-- <a class="primary_btn" href="#"><span>Learn More</span></a> -->
            </div>
         </div>
         <div class="border-line"></div>
         <img class="shape1" src="img/shape1.png" alt=""/>		
         <img class="shape2" src="img/shape2.png" alt=""/>		
         <img class="shape3" src="img/shape1.png" alt=""/>		
      </div>
      <div class="row features_content bottom-features" data-aos="fade-up">
         <div class="col-lg-5">
            <div class="common_style">
               <p class="line">Modern Design Trends</p>
               <h3>Understand the requirements</h3>
               <p>We believe that the client requirement or the initial idea/concept is the most important aspect of any project we take over. So in order to build trust, it’s important to understand the requirements first. By taking the first step seriously, we assure that we deliver the best by creating a seamless brand to motivate and encourage the users.</p>
               <!-- <a class="primary_btn" href="#"><span>Learn More</span></a> -->
            </div>
         </div>
         <div class="col-lg-5 offset-lg-2">
            <div class="big_f_left">
               <img class="img-fluid" src="img/f-img2.svg" alt="">
            </div>
         </div>
         <div class="border-line"></div>
         <img class="shape1" src="img/shape1.png" alt=""/>		
         <img class="shape2" src="img/shape2.png" alt=""/>		
         <img class="shape3" src="img/shape1.png" alt=""/>		
      </div>
   </div>
</section>
<!--================End Big Features Area =================-->
<!--================ Start Testimonial Area =================-->
<div class="section_gap_top testimonial_area">
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-lg-8 text-center">
            <div class="main_title" data-aos="fade-up">
               <p class="top_title">Founder Message</p>
               <h2>What Founder Say</h2>
               <p></p>
            </div>
         </div>
      </div>
      <div class="row justify-content-center">
         <div class="col-lg-6 text-center">
            <div class="active_testimonial" data-slider-id="1">
               <!-- single testimonial -->
               <div class="single_testimonial">
                  <div class="testimonial_head" data-aos="fade-up">
                     <img src="img/animoji.jpg"/>
                     <h4><a href="https://katheesh.js.org" target="_blank"> Mr. S. KATHEESKUMAR</a></h4>
                     <div class="review">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                     </div>
                  </div>
                  <div class="testimonial_content" data-aos="fade-up">
                     <p style="font-family: 'Rajdhani'; color: black; font-size: 17px; font-style: normal;">
                      I ❤️ three important point to work with efficient <br>
                     🔖Efficiency consists in a resolute mind. Other things come thereafter." <br>
                     🔖Nature is my friend, life is my philoso teacher, history is my guide" <br>
                     🔖My jobs is to not be easy on people. My job is make them better"</p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<!--================ End Testimonial Area =================-->
<!--================Impress Area =================-->
<section class="impress_area">
   <div class="container">
      <div class="impress_inner" data-aos="fade-up">
         <h2 style="color: black;">Got Impressed to our Services?</h2>
         <p style="color: black;"></p>
         <router-link to="/contact"><a class="primary_btn"><span>GET A QUOTE</span></a></router-link>
      </div>
   </div>
</section>
<!--================End Impress Area =================-->


<Footer/>

  </div>
</template>

<style>
.home_right_img {
  background: transparent;
  width: 100%;
  position: relative;
}
.home_right_img::after {
  content: "";
  position: absolute;
  top: 10px;
  right: 10px;
  height: 120%;
  width: 100%;
  background: url(../../public/img/banner/home-right.svg) no-repeat center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: 90%;
}
.home_right_img {
  position: absolute;
  bottom: 0;
  -webkit-animation: action 1s infinite  alternate;
  animation: action 1s infinite  alternate;
}
@-webkit-keyframes action {
    0% { transform: translateY(0); }
    100% { transform: translateY(-10px); }
}
@keyframes action {
    0% { transform: translateY(0); }
    100% { transform: translateY(-10px); }
}

.animate {
  -webkit-animation: anima 1s infinite  alternate;
  animation: anima 1s infinite  alternate;
}
@-webkit-keyframes anima {
  0% { transform: translateY(0); }
  100% { transform: translateY(-10px); }
}
@keyframes anima {
  0% { transform: translateY(0); }
  100% { transform: translateY(-10px); }
}
</style>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer
  }
};
</script>
